import { render, staticRenderFns } from "./FeesPage.vue?vue&type=template&id=490a7c8c&scoped=true"
import script from "./FeesPage.vue?vue&type=script&lang=js"
export * from "./FeesPage.vue?vue&type=script&lang=js"
import style0 from "./FeesPage.vue?vue&type=style&index=0&id=490a7c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a7c8c",
  null
  
)

export default component.exports